export function isDevMode(): boolean {
  return import.meta.env.DEV;
}

export function isTestMode(): boolean {
  return import.meta.env.VITE_TEST === "1" || import.meta.env.VITE_TAURI_TEST === "1";
}

export function isDevOrTestMode(): boolean {
  return isDevMode() || isTestMode();
}
